export const iconFontAwesomeCodingBarcode = (
	<i className="fa-solid fa-barcode"></i>
);
